// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_use","cls2":"Comments-cls2_dpt Comments-cls1_use"};